export default __webpack_public_path__ + "static/devesecops-support-mobile3-1619ee1d1eccc401c9defa583e8d3e4a.jpg";